import React from 'react';
import { HomeIcon, UserRoundIcon, UsersRoundIcon } from 'lucide-react';
import { Logo } from '../Logo';
import type { BoothMode } from '../../types/booth';
interface BoothTopBarProps {
  mode: BoothMode;
  onModeChange: (mode: BoothMode) => void;
  onHome?: () => void;
}
const MODES: {
  id: BoothMode;
  label: string;
  icon: typeof UsersRoundIcon;
}[] = [{
  id: 'rep',
  label: 'Rep-guided',
  icon: UsersRoundIcon
}, {
  id: 'self',
  label: 'Self-guided',
  icon: UserRoundIcon
}];
export function BoothTopBar({
  mode,
  onModeChange,
  onHome
}: BoothTopBarProps) {
  return <header className="flex h-16 shrink-0 items-center justify-between border-b border-navy-900/[0.06] bg-white/85 px-7 backdrop-blur-md" data-id="element-133" data-mp="24glwcytdaphm">
      <div className="flex items-center gap-4" data-id="element-134" data-mp="29ene9gf24iri">
        {onHome && <button type="button" onClick={onHome} aria-label="Back to all chapters" className="flex h-9 w-9 items-center justify-center rounded-full border border-navy-900/10 text-navy-700 transition hover:bg-mist-100 focus:outline-none focus-visible:ring-2 focus-visible:ring-pulse-iris" data-id="element-135" data-mp="t1q5mehg4xkp">
            <HomeIcon className="h-4 w-4" data-id="element-136" data-mp="170i4e478kkws" />
          </button>}
        <div className="flex items-center gap-2.5" data-id="element-137" data-mp="1kyyiig7fhdoy">
          <Logo width={22} height={22} data-id="element-138" data-mp="1kwc35ueaptw6" />
          <span className="text-[13px] font-semibold tracking-[0.16em] text-navy-900" data-id="element-139" data-mp="1fzc6ub7905i9">REKOVELLE®</span>
          <span className="text-[12px] text-slate-400" data-id="element-140" data-mp="1tylf8op7pvbo">(follitropin delta)</span>
        </div>
      </div>
      <div className="flex items-center gap-3" data-id="element-141" data-mp="1pwqdxk7a7hxw">
        <span className="rounded-full bg-amber-100 px-2.5 py-1 text-[10px] font-semibold uppercase tracking-wider text-amber-800" data-id="element-142" data-mp="1pvyqiwnu8qip">
          Demo
        </span>
        <div className="flex gap-1 rounded-full bg-mist-100 p-1" role="radiogroup" aria-label="Presentation mode" data-id="element-143" data-mp="1yreg31hk8jih">
          {MODES.map(({
          id,
          label,
          icon: Icon
        }) => <button key={id} role="radio" aria-checked={mode === id} onClick={() => onModeChange(id)} className={`flex items-center gap-1.5 rounded-full px-3.5 py-1.5 text-[12px] font-medium transition focus:outline-none focus-visible:ring-2 focus-visible:ring-pulse-iris ${mode === id ? 'bg-navy-900 text-white' : 'text-navy-700 hover:text-navy-900'}`} data-id="element-144" data-mp="28osukvjxay85">
              <Icon className="h-3.5 w-3.5" data-id="element-145" data-mp="2zfgn7mbybl87" />
              {label}
            </button>)}
        </div>
      </div>
    </header>;
}